import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import { translations } from '../constants';
import { ThemeContext } from '../containers/ThemeContext';

import '../styles/components/SectionImageText.css';

const uniqueString = require('unique-string');

class SectionImageText extends Component {
    constructor(props) {
        super(props);

        this.state = {
            elementId: uniqueString()
        };
    }

    showModal = () => {
        console.log(this.context);
    };

    offerScrollFunction = async () => {
        try {
            const elemID = this.state.elementId;
            const element = $(`#${elemID}`);
            const elementSpan = $(`#${elemID} span`);
            const animateFrom = element.offset().top;
            const animateTo = element.offset().top + element.outerHeight();
            const scrollTop = $(window).scrollTop();
            if (
                scrollTop > animateFrom - $(window).height() &&
                scrollTop < animateTo
            ) {
                const parallaxPosition = (
                    -(animateFrom - $(window).height() - scrollTop) /
                    ((animateTo - (animateFrom - $(window).height())) / 100)
                ).toPrecision(3);
                elementSpan.css(
                    'background-position',
                    `center ${parallaxPosition}%`
                );
            }
        } catch (err) {
            console.error(err);
        }
    };

    componentDidMount() {
        $(document).ready(() => {
            $(window).scroll(this.offerScrollFunction);
        });
    }

    componentWillUnmount() {
        $(window).off('scroll', this.offerScrollFunction);
    }

    render() {
        const {
            backgroundImage,
            descText,
            motoconcierge,
            paddingBottom,
            paddingTop,
            showButtonContact,
            text,
            wrapperClasses
        } = this.props;

        return (
            <section
                id={`${this.state.elementId}`}
                className={`section-image-text ${
                    wrapperClasses ? wrapperClasses : ''
                }`}
                style={
                    paddingTop !== 0 && paddingBottom !== 0
                        ? {
                              paddingTop: paddingTop - 20 + 'px',
                              paddingBottom: paddingBottom - 20 + 'px'
                          }
                        : {}
                }
            >
                <div className="row">
                    <div className="col-12 z-index-10">
                        <span
                            style={{
                                backgroundImage: backgroundImage
                                    ? `url(${backgroundImage})`
                                    : '#000'
                            }}
                        >
                            {text}
                            {this.props.secLine && (
                                <React.Fragment>
                                    <br />
                                    {this.props.secLine}
                                </React.Fragment>
                            )}
                            {this.props.thirdLine && (
                                <React.Fragment>
                                    <br />
                                    {this.props.thirdLine}
                                </React.Fragment>
                            )}
                        </span>

                        {descText && (
                            <div className="row">
                                <div className="col-12 col-sm-6 offset-sm-3 col-md-5 offset-md-6">
                                    <p>{descText}</p>
                                </div>
                            </div>
                        )}
                    </div>
                    {showButtonContact && (
                        <div className="col-12 offset-0 col-md-6 offset-md-3 section-image-button">
                            <button
                                className="btn btn-general btn-general--secondary"
                                onClick={this.context.showModalContact}
                            >
                                {
                                    translations[
                                        'button.contactWithUsAndOpenModal.text'
                                    ]
                                }
                            </button>
                        </div>
                    )}
                    {motoconcierge && (
                        <>
                            <div className="col-12 offset-0 col-xl-9 offset-xl-3 text-left section-image-button">
                                <p style={{ marginBottom: '5px' }}>
                                    Czekamy na Twój ruch.
                                </p>
                                <p style={{ color: 'black' }}>
                                    Skontaktuj się z nami i przedstaw, jak
                                    możemy Ci pomóc.
                                </p>
                            </div>
                            <div
                                className="col-12 offset-0 col-xl-9 offset-xl-3 text-left"
                                style={{ marginTop: '40px' }}
                            >
                                <Link
                                    className="btn btn-general btn-general--primary"
                                    to="/flota"
                                    style={{ marginRight: '10px' }}
                                >
                                    Zobacz flotę
                                </Link>
                                <button
                                    className="btn btn-general btn-general--secondary"
                                    onClick={this.context.showModalContact}
                                >
                                    {
                                        translations[
                                            'button.contactWithUsAndOpenModal.text'
                                        ]
                                    }
                                </button>
                            </div>
                        </>
                    )}
                </div>
            </section>
        );
    }
}

SectionImageText.propTypes = {
    backgroundImage: PropTypes.string.isRequired,
    wrapperClasses: PropTypes.string,
    text: PropTypes.string.isRequired,
    secLine: PropTypes.string,
    descText: PropTypes.string,
    paddingTop: PropTypes.number,
    paddingBottom: PropTypes.number,
    showButtonContact: PropTypes.bool
};

SectionImageText.defaultProps = {
    wrapperClasses: '',
    paddingTop: 0,
    paddingBottom: 0,
    showButtonContact: false
};

SectionImageText.contextType = ThemeContext;

export default SectionImageText;
